<template>
  <div class="team-list__item">
    <nuxt-link
      v-if="teamMember && teamMember.url"
      :to="teamMember.url"
      class="team-list__link"
    >
      <div v-if="teamMember.columns.asset" class="team-list__image-wrapper">
        <Media
          :path="teamMember.columns.asset"
          class="team-list__image"
        />
      </div>
    </nuxt-link>
    <div class="team-list__text">
      <nuxt-link
        v-if="teamMember && teamMember.url"
        :to="teamMember.url"
        class="team-list__link"
      >
        <span class="team-list__name">{{ teamMember.columns.name }}</span>
        <span class="team-list__position">{{ teamMember.columns.position }}</span>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import { Resource } from 'beisheim/models'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Media from 'beisheim/components/elements/media'

export default {
  components: {
    Media
  },
  mixins: [editable],
  computed: {
    teamMember () {
      return Resource.find(this.resource.columns.teamMember)
    }
  }
}
</script>
